<template>
  <div>
    <v-toolbar color="transparent" dense flat>
      <v-toolbar-title>{{$t('settings_menu_security')}}</v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>

    <div class="pa-3">
      <v-switch v-model="pinModel" :label="pinLabel" :disabled="pinSet!=tmpPinState "></v-switch>
      <v-btn v-if="pinSet && !showRemovePin && !showSetPin" flat @click="showSetPin = true">{{$t('pin_btn_change_pin')}}</v-btn> 

      <v-form v-model="pinSetValid" v-if="showSetPin">
        <v-container>
          <v-layout column>
              <v-text-field v-model="pin"
                :rules="setPinRules"
                :label="$t('pin_new_enter')"
                :type="'password'"
                required
              />
              <v-text-field
                v-model="confirmPin"
                :rules="confirmPinRules"
                :label="$t('pin_new_confirm')"
                :type="'password'"
                required
              />
          </v-layout>
        </v-container>
        <v-btn :disabled="!pinSetValid" color="primary" flat  @click="setPin()">{{$t('Ok')}}</v-btn>
        <v-btn  @click="cancelSetPin()" color="primary" flat>{{$t('cancel')}}</v-btn>
      </v-form>

      <v-form v-if="showRemovePin">
        <v-container>
          <v-text-field v-model="confirmPin"
            :label="$t('pin_confirm')"
            :type="'password'"
            required
          />
        </v-container>
        <v-btn  @click="removePin()" color="primary" flat>{{$t('Ok')}}</v-btn>
        <v-btn  @click="clearRemovePin()" color="primary" flat>{{$t('cancel')}}</v-btn>
      </v-form>
    </div>

  </div>
</template>

<script>

export default {
  components: { 
    
  },
  props: {

  },
  data () {
    return {
      pinSetValid: true,
      pinSet: false,
      showSetPin: false,
      showRemovePin: false,
      pin: '',
      setPinRules: [
        v => (v && v.length >= 4 && v.length < 8) || this.$t('error_pin_length')
      ],
      confirmPin: '',
      confirmPinRules: [
        v => (v && v.length >= 4 && v.length < 8 && v == this.pin) || this.$t('pin_not_match')
      ],
      tmpPinState: false,
    }
  },
  computed: {
    pinModel: {
      get: function () {
      return this.tmpPinState
      },
      set: function (newValue) {
        this.tmpPinState = newValue
        if(newValue == true)
          this.showSetPin = true
        else
          this.showRemovePin = true
      }
    },
    pinLabel: function() {
      return this.tmpPinState?this.$t('pin_turn_off'):this.$t('pin_enable')
    }
  },
  mounted(){
    //console.log("-- mounted showSetPin:" + this.showSetPin)
    this.$store.dispatch('isApplicationPinSet').then((data) => { 
      //console.log("-- updated isApplicationPinSet pinSet:" + this.pinSet)
      this.pinSet = data
      this.tmpPinState = this.pinSet
    })
  },
  methods: {
    pinChanged($event) {
      console.log("pinClicked:"+this.pinSet)
      if(this.pinSet) {
        this.showRemovePin = true
        this.pinSet = true
      }
      else {
        this.showSetPin = true
        this.pinSet = false
      }
       this.tmpPinState = this.pinSet
      console.log("pinClicked after show:"+this.pinSet)
      //event.stopPropagation()
      //event.preventDefault()     
    },
    setPin() {
      //console.log("-- setApplicationPin pin:" + this.pin)
      this.$store.dispatch('setApplicationPin', this.pin).then((set) => { 
        //console.log("-- setApplicationPin returned:" + set)
        if(set) {
          this.pinSet = true
          this.clearPinFields()
        }
      })
    },
    removePin() {
      //console.log("-- clearApplicationPin")
      this.$store.dispatch('verifyApplicationPin', this.pin).then((isVerified) => {
        if(isVerified) {
          this.$store.dispatch('clearApplicationPin')
          this.pinSet = false
          this.clearRemovePin()
        }
      })
    },
    clearPinFields() {
      //console.log("-- clearPinFields")
      this.pin = ""
      this.confirmPin = ""
      this.showSetPin = false
      this.tmpPinState = this.pinSet
    },
    cancelSetPin() {
      //console.log("-- cancelSetPin")
      this.clearPinFields()
    },
    clearRemovePin() {
      //console.log("-- clearRemovePinFields")
      this.confirmPin = ""
      this.showRemovePin = false
      this.tmpPinState = this.pinSet
    }
  }
}
</script>

